import React from "react";

type isOffline = boolean; 

export const OfflineStatusContext = React.createContext<boolean>(false);

export function useOfflineStatus(): isOffline {
	return React.useContext(OfflineStatusContext);
}
